import Api from './api';
const APIRoot = process.env.REACT_APP_API_ROOT;


class Auth {
  accessToken;
  idToken;
  expiresAt;

  async login({
    username,
    password,
    originalUrl,
    onError
  }) {
    try {
      const responseData = await Api({
        endpoint: '/v2/login',
        method: 'POST',
        body: {
          username,
          password
        },
        onError
      });


      localStorage.setItem("accessToken", responseData.token);
      localStorage.setItem("username", responseData.user.username);
      /* used for displaying warnings */
      localStorage.setItem("role", responseData.user.role);

      window.location.href = originalUrl;
    } catch (e) {
      throw new Error(e.message)
    }
  }

  getAccessToken() {
    return this.accessToken;
  }

  getIdToken() {
    return this.idToken;
  }

  logout() {
    this.accessToken = null;
    this.expiresAt = 0;

    localStorage.removeItem('accessToken');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = this.expiresAt;
    return new Date().getTime() < expiresAt;
  }
}

export const auth = new Auth();